import React from "react";
import TextField from "../TextField";
import { PatternFormat } from "react-number-format";

interface PhoneNumberFormatProps {
  formikVal: string;
  formikErrors?: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  error?: boolean;
  helperText?: string;
}

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const PhoneNumberCustomInput = React.forwardRef<any, CustomProps>(
  function PhoneNumberCustomInput(props, ref) {
    const { onChange, name, ...other } = props;

    return (
      <PatternFormat
        {...other}
        getInputRef={ref}
        format="(###) ###-####"
        mask="_"
        onValueChange={(values) => {
          onChange({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
      />
    );
  }
);

const PhoneNumberFormat: React.FC<PhoneNumberFormatProps> = ({
  formikVal,
  formikErrors,
  handleChange,
  label,
  error,
  helperText,
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center mb-1">
        <label
          htmlFor="phoneNumber"
          className="block text-sm font-medium text-gray-900"
        >
          {label}
        </label>
      </div>
      <TextField
        type="tel"
        id="phoneNumber"
        name="phoneNumber"
        value={formikVal || ""}
        onChange={handleChange}
        error={error}
        helperText={helperText}
        fullWidth
        InputProps={{
          inputComponent: PhoneNumberCustomInput as any,
        }}
      />
    </div>
  );
};

export default PhoneNumberFormat;
